<template>
  <div class="totalBox">
    <div class="headBox">
      <div class="company">
        <div class="first">
          <img src="@/assets/gongsixinxi.png" />
          <span>公司信息</span>
        </div>
        <div
          style="font-size:1.25rem;line-height:1.5rem;margin-bottom:5.3rem;height:1.25rem;margin-right:1rem;"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
        >
          {{ companyName }}
        </div>
        <div style="display:flex;" class="btnPos">
          <!--          <div class="btn changePassword" @click="showComponent('revisePassword')">修改密码</div>-->
          <div class="btn companyInfo" @click="goPerson">企业信息</div>
        </div>
      </div>
      <div class="account">
        <div class="first">
          <img src="@/assets/zhanghuyue.png" />
          <span>账户余额</span>
        </div>
        <div class="second">
          <span>支付账户：</span>
          <el-select v-model="key" class="accountType">
            <el-option value="baofu" label="众邦银行"></el-option>
            <!-- <el-option value="baofuStop" label="众邦银行账户已停用" disabled></el-option> -->
          </el-select>
          <span>账户总余额：</span>
          <h4 v-loading="loading" element-loading-spinner="el-icon-loading">
            {{ account.total | money }}
          </h4>
          <h5>元</h5>
        </div>
        <div class="second second2">
          <!-- <span>支付冻结：</span>
          <h5>{{ account.frozen||0 }}元</h5>-->
          <!-- <span>可用余额：</span>
          <h5>{{ account.left }}元</h5>-->
        </div>
        <div
          style="display:flex;width:100%;justify-content:space-around;"
          class="btnPos"
        >
          <div class="btn charge" @click="showComponent('deposit')">充值</div>
          <el-button
            class="btn cash"
            @click="goCash"
            :disabled="isStop == 1"
            type="primary"
          >
            提现
          </el-button>
          <el-button
            class="btn record"
            @click="showComponent('record')"
            :disabled="isStop == 1"
            type="primary"
          >
            收支记录
          </el-button>
        </div>
      </div>
      <div class="order">
        <div class="first">
          <img src="@/assets/wodedingdan.png" />
          <span>我的订单</span>
        </div>
        <div class="second">
          <span>待支付订单：</span>
          <h5>{{ order.num }}</h5>
        </div>
        <div class="second second2">
          <span>待支付金额：</span>
          <h4>{{ order.money | money }}</h4>
          <h5>元</h5>
        </div>
        <el-button
          class="btn record btnPos"
          type="primary"
          @click="toOrder"
          :disabled="isStop == 1"
        >
          查看详情
        </el-button>
      </div>
    </div>
    <div style="display:flex;align-items: baseLine;">
      <div class="countChartBox">
        <div class="first">
          <div style="display:flex;">
            <img src="@/assets/shouzhijilu.png" />
            <span>收支统计</span>
          </div>
          <ComponentDatePicker @dateChange="dateChange"></ComponentDatePicker>
        </div>
        <div id="countChart" :style="{ width: countChartWidth }"></div>
      </div>
      <div class="pieBox">
        <div class="flexBox firstBox">
          <div class="firstChild">
            <img src="@/assets/benyuexiangmujieshuqingkuang.png" />
            <div>本月项目完成情况</div>
          </div>
          <dic-select
            @dic-select-obj="saveProId"
            :fuzzyDef="searchAjaxPro"
            :prop="ProProp"
            :defaultActive="defaultObj"
            ajaxQuery="title"
            placeholder="项目名称"
          ></dic-select>
        </div>
        <div class="childBox">
          <div id="pieWrapper" :style="{ width: pieWrapperWidth }"></div>
          <div class="flexBox">
            <div class="pieNum pieNum1">
              已完成
              <b>{{ finishNum }}</b>
              单
            </div>
            <div class="pieNum pieNum2">
              未完成
              <b>{{ unfinishNum }}</b>
              单
            </div>
          </div>
        </div>
      </div>
    </div>
    <component
      :is="componentName"
      v-if="componentName"
      :cashObj="cashObj"
    ></component>
    <el-dialog title="温馨提示" :visible.sync="stopFlag" width="416px" center>
      <div
        slot="title"
        style="font-size:24px;text-align:left;font-weight:bold;"
      >
        温馨提示
      </div>
      <span>
        尊敬的用户，您的支付账号已被停用，请联系客服进行恢复，给您带来的不便敬请谅解！
      </span>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>
<script>
import {
  indexInfo,
  inOutInfo,
  currMonthInfo,
  currMonthInfoProject,
  academy,
  withdrawals
} from '@/api/ajax';
import datePicker from '@/Mixin/datePicker';
import { getStorage, setStorage } from '@/tools/storage';
import dicSelect from '@/components/Common/dicSelect.vue';
import ComponentDatePicker from '@/components/Common/newDate.vue';
import cash from './cash.vue'; //提现
import cashConfirm from './cashConfirm.vue'; //提现二次确认
import cashResult from './cashResult.vue'; //提现审核页
import record from './record.vue'; //收支记录
import detail from './detail.vue'; //收支记录
import echarts from 'echarts'; //支付明细
import changePassword from './changePassword.vue';
import deposit from './deposit.vue';
import revisePassword from './revisePassword.vue';

export default {
  mixins: [datePicker],
  data() {
    return {
      projectId: null,
      ProProp: {
        label: 'projectName',
        code: 'projectId'
      },
      defaultObj: {},
      key: 'baofu',
      companyName: '',
      account: {
        total: '',
        frozen: '',
        left: ''
      },
      order: {
        num: '',
        money: ''
      },
      countData: [
        {
          name: '支付',
          type: 'bar',
          data: [15000, 30000, 40000, 20000, 24000, 35000],
          barWidth: '10px',
          label: {
            show: true,
            position: 'top',
            color: '#fff',
            backgroundColor: '#4889FF',
            padding: 2
          },
          itemStyle: { barBorderRadius: 5 }
        },
        {
          name: '消费',
          barWidth: '10px',
          type: 'bar',
          data: [13000, 32000, 45000, 10000, 21000, 25000],
          label: {
            show: true,
            position: 'top',
            color: '#fff',
            backgroundColor: '#FFB148',
            padding: 2
          },
          itemStyle: { barBorderRadius: 5 }
        }
      ],
      xRay: ['1月', '2月', '3月', '4月', '5月', '6月'],
      unfinishNum: 0,
      finishNum: 0,
      searchAjaxPro: currMonthInfoProject,
      showCash: false,
      showCashConfirm: false,
      showRecord: false,
      showDetail: false,
      showPassword: false,
      searchQuery: {},
      componentName: '',
      cashObj: {},
      startDate: '',
      endDate: '',
      countChartWidth: '800px',
      pieWrapperWidth: '500px',
      isStop: 0, //0是未停用 1是已停用
      stopFlag: false,
      loading: true
    };
  },
  computed: {
    pieData() {
      return [
        { value: this.finishNum, name: '已完成' },
        { value: this.unfinishNum, name: '未完成' }
      ];
    }
  },
  components: {
    dicSelect,
    cash,
    cashConfirm,
    record,
    detail,
    ComponentDatePicker,
    changePassword,
    deposit,
    cashResult,
    revisePassword
  },
  methods: {
    dateChange(v) {
      if (v) {
        this.startDate = v[0];
        this.endDate = v[1];
        this.renderBar();
      } else {
        this.startDate = '';
        this.endDate = '';
        this.renderBar();
      }
    },
    goCash() {
      //提现
      withdrawals.loadLastWithdrawals().then(res => {
        //查看提现状态
        let resData = res.data.data;
        if (!resData.id) {
          this.componentName = 'cash';
        } else {
          this.cashObj = resData;
          this.componentName = 'cashResult';
        }
      });
    },
    showComponent(componentName) {
      this.componentName = componentName;
    },
    toOrder() {
      this.$router.push({
        name: 'projectSettledList'
      });
    },
    goPerson() {
      this.$router.push({
        name: 'person'
      });
    },
    drawBar(id) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          //图例
          data: ['支付', '消费'],
          x: 'left',
          y: '30px',
          itemWidth: 10,
          itemHeight: 10
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          containLabel: true
        },
        color: ['#4889ff', '#FFB148'], //柱状图颜色
        xAxis: [
          {
            type: 'category',
            data: this.xRay,
            axisLabel: {
              textStyle: {
                color: '#bfbfbf'
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#bfbfbf'
              }
            }
          }
        ],
        series: this.countData //数据源
      });
    },
    renderBar() {
      //渲染柱状图
      inOutInfo({
        startDate: this.startDate,
        endDate: this.endDate
      }).then(
        ({
          data: {
            data: { monthList, statList }
          }
        }) => {
          this.xRay = monthList;
          let l = [];
          let r = [];
          statList.forEach(item => {
            l.push(item.in);
            r.push(item.out);
          });
          this.countData[0].data = l;
          this.countData[1].data = r;
          this.drawBar('countChart');
        }
      );
    },
    renderPie() {
      //渲染饼状图
      currMonthInfo({
        id: this.projectId
      }).then(res => {
        try {
          this.finishNum = res.data.data.finishSum || '';
          this.unfinishNum = res.data.data.taskSum - res.data.data.finishSum;
          this.defaultObj = {
            projectName: res.data.data.projectName,
            projectId: res.data.data.projectId
          };
          this.drawPie('pieWrapper');
        } catch (error) {}
      });
    },
    drawPie(id) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
          x: 'center',
          y: 'center'
        },
        color: ['#4889ff', '#FFB148'],
        legend: {
          show: false,
          orient: 'vertical',
          x: 'center',
          y: 'bottom',
          tooltip: {
            show: true,
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          }
        },
        series: [
          {
            name: '完成情况',
            type: 'pie',
            radius: ['50%', '70%'],
            hoverAnimation: false,
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: '{b}:{d}%'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: this.pieData
          }
        ]
      });
    },
    saveProId(val) {
      this.projectId = val.projectId;
      this.renderPie();
    }
  },
  async created() {
    let width = document.body.clientWidth;
    this.countChartWidth = width * 0.55 + 'px';
    this.pieWrapperWidth = width * 0.38 + 'px';
  },
  async mounted() {
    this.renderBar();
    this.renderPie();
    let {
      data: { data }
    } = await indexInfo();
    this.loading = false;
    this.companyName = data.companyName;
    this.isStop = data.isStop;
    if (+this.isStop === 1) {
      this.stopFlag = true;
      this.key = 'baofuStop';
    }
    this.account = {
      total: data.balance,
      frozen: data.frozenBalance,
      left: data.balance
    };
    this.order = {
      num: data.orderCount,
      money: data.totalOrderPrice
    };
  }
};
</script>
<style lang="scss" scoped>
.totalBox {
  background: #f7fbff;
}
.headBox {
  display: flex;
  margin-bottom: 1.88rem;
}
.flexBox {
  display: flex;
  // align-items: center;
}
.countChartBox {
  background: #fff;
  width: 58%;
  margin: 0 1%;
  padding: 1%;
  .first {
    margin-bottom: 1.7rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 0.63rem;
    }
    span {
      color: #b2b2b2;
      font-size: 1.25rem;
    }
  }
}
#countChart {
  // width: 800px;
  height: 45rem;
  background: #fff;
  margin-bottom: 1.88rem;
  margin-right: 2rem;
}
.btn {
  cursor: pointer;
  width: 7.38rem;
  height: 2.88rem;
  color: #fff;
  font-size: 1rem;
  line-height: 2.88rem;
  text-align: center;
  border-radius: 0.5rem;
}
.company {
  background: #fff;
  width: 30.31rem;
  height: 16rem;
  margin-right: 1.88rem;
  padding: 1.19rem 0 1.25rem 1.88rem;
  border-radius: 0.75rem;
  position: relative;
  .first {
    margin-bottom: 1.7rem;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    img {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 0.63rem;
    }
    span {
      color: #b2b2b2;
      font-size: 1.25rem;
    }
  }
  > div {
    text-align: left;
  }

  .changePassword {
    margin-right: 3.75rem;
    background: rgba(115, 127, 236, 1);
    box-shadow: 0.25rem 0.25rem 0.5rem 0rem rgba(115, 127, 236, 0.5);
  }
  .companyInfo {
    background: rgba(78, 166, 254, 1);
    box-shadow: 0.25rem 0.25rem 0.5rem 0rem rgba(78, 166, 254, 0.5);
  }
}
.account {
  background: #fff;
  width: 40rem;
  height: 16rem;
  margin-right: 2rem;
  border-radius: 0.75rem;
  padding: 1.19rem 0 1.25rem 1.88rem;
  position: relative;
  .first {
    margin-bottom: 1.7rem;
    display: flex;
    align-items: center;
    img {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 0.63rem;
    }
    span {
      color: #b2b2b2;
      font-size: 1.25rem;
    }
  }
  .second {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    span {
      font-size: 0.88rem;
      color: #bfbfbf;
    }
    .accountType {
      width: 8.63rem;
      margin-left: 0.3rem;
      margin-right: 0.3rem;
    }
    h4 {
      font-size: 1.88rem;
      margin-left: 0.3rem;
    }
    h5 {
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }
  .second2 {
    margin-top: 0.31rem;
    margin-bottom: 1.88rem;
    height: 1.2rem;
    span {
      line-height: 1.25rem;
    }
    h5 {
      margin: 0 0.3rem;
    }
  }
  .charge {
    background: rgba(235, 142, 14, 1);
    box-shadow: 0.25rem 0.25rem 0.5rem 0rem rgba(235, 142, 14, 0.5);
  }
  .cash {
    background: rgba(246, 194, 73, 1);
    box-shadow: 0.25rem 0.25rem 0.5rem 0rem rgba(246, 194, 73, 0.5);
    border: none;
  }
  .record {
    background: rgba(78, 166, 254, 1);
    box-shadow: 0.25rem 0.25rem 0.5rem 0rem rgba(78, 166, 254, 0.5);
    margin-left: 0;
    border: none;
  }
}
.order {
  background: #fff;
  width: 30rem;
  height: 16rem;
  border-radius: 0.75rem;
  padding: 1.19rem 0 1.25rem 1.88rem;
  position: relative;
  .first {
    margin-bottom: 1.7rem;
    display: flex;
    align-items: center;
    img {
      width: 1.63rem;
      height: 1.63rem;
      margin-right: 0.63rem;
    }
    span {
      color: #b2b2b2;
      font-size: 1.25rem;
    }
  }
  .second {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 1.05rem;
    span {
      font-size: 0.88rem;
      color: #bfbfbf;
    }
    .accountType {
      width: 8.63rem;
      margin-left: 0.3rem;
      margin-right: 0.3rem;
    }
    h4 {
      font-size: 1.88rem;
      margin-left: 0.3rem;
    }
    h5 {
      font-size: 1rem;
      line-height: 1.25rem;
    }
  }
  .record {
    background: rgba(78, 166, 254, 1);
    box-shadow: 0.25rem 0.25rem 0.5rem 0rem rgba(78, 166, 254, 0.5);
  }
}
.pieBox {
  padding: 1%;
  width: 40%;
  height: 37rem;
  background: #fff;
  .firstBox {
    justify-content: space-between;
    .firstChild {
      display: flex;
    }
    img {
      width: 1.63rem;
      height: 1.63rem;
      border-radius: 50%;
      margin-right: 0.63rem;
    }
    div {
      color: #b1b1b1;
      font-size: 1.25rem;
    }
  }
  .childBox {
    margin-top: 1.63rem;
    padding: 1rem;
    // width: 28.88rem;
    // height: 30rem;
    overflow: hidden;
    background: #fff;
    #pieWrapper {
      width: 100%;
      height: 25rem;
      transform: translateX(-25px);
    }
    .flexBox {
      justify-content: center;
      align-items: center;
    }
    .pieNum {
      color: #bfbfbf;
      font-size: 0.88rem;
      b {
        color: #000;
        font-size: 1.13rem;
      }
    }
    .pieNum1 {
      margin-right: 3rem;
    }
    .pieNum::before {
      content: '';
      width: 0.63rem;
      height: 0.63rem;
      border-radius: 50%;
      margin-right: 0.6rem;
      display: inline-block;
    }
    .pieNum1::before {
      background: #4889ff;
    }
    .pieNum2::before {
      background: #ffb148;
    }
  }
}
.btnPos {
  position: absolute;
  bottom: 20px;
  left: 10px;
}
</style>
